import Vue from 'vue';
import { apiPath } from '../constants';

export default Vue.resource(
  `${apiPath}/draft-apps{/id}/obb{/type}{/packageId}{/fileId}/`,
  {},
  {
    getMainObbs: {
      method: 'GET',
      params: { type: 'main' },
    },
    getPatchObbs: {
      method: 'GET',
      params: { type: 'patch' },
    },
    attachToPackage: {
      method: 'PUT',
      params: { type: 'assign' },
    },
    detach: {
      method: 'DELETE',
      params: { type: 'unassign' },
    },
  },
  {
    transformToCamelCase: true,
  },
);
